export default __webpack_public_path__ + "static/media/akademik_halollik_kodeksi.b6c22008.pdf";